import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MediImg from "../../../images/medical.png";

const Medical = () => {
  const navigate = useNavigate();

  // Hero Section with Background Image
  const HeroSection = () => (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "50vh", md: "70vh" },
        backgroundImage: `url(${MediImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
        }}
      />

      {/* Content */}
      <Container
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: "#fff",
            letterSpacing: 2,
            opacity: 0.9,
          }}
        >
          Specialization
        </Typography>

        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mt: 1,
            mb: 2,
            fontSize: { xs: "1.6rem", md: "2rem" },
          }}
        >
          Medical & Healthcare
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.85)",
            maxWidth: 600,
            mb: 3,
          }}
        >
          Delivering exceptional healthcare staffing solutions with qualified
          professionals dedicated to improving patient care and organizational
          excellence.
        </Typography>

        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: "#1976d2",
            px: 4,
            py: 1.2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "15px",
            "&:hover": {
              backgroundColor: "#115293",
            },
          }}
          onClick={() => navigate("/contact-us")}
        >
          Get in Touch
        </Button>
      </Container>
    </Box>
  );

  return (
    <Box>
      <HeroSection />

      {/* Medicine Jobs Section */}
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              mb: { xs: 6, md: 8 },
              color: "#0a3b4a",
              fontSize: { xs: "2rem", md: "2.4rem" },
            }}
          >
            Medicine Jobs
          </Typography>

          {/* Row 1 - 4 columns */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Medical assistant */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },

                  }}
                >
                  Medicine
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Medical assistant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Helps patients by providing information, services and
                  assistance. Maintains medical supplies inventory and performs
                  preventive maintenance to keep equipment operating. Verifies
                  patient information by interviewing patients, recording
                  medical history and confirming purpose of visit. Prepares
                  patients for examination by performing preliminary physical
                  tests and recording vital signs. Saves doctors&apos; time by
                  helping with office procedures and basic clinical tasks.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Medical receptionist */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },

                  }}
                >
                  Medicine
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Medical receptionist
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Serves patients by greeting and helping them, scheduling
                  appointments and maintaining records and accounts. Welcomes
                  patients and visitors in person or on the telephone and
                  answers or refers enquiries. Keeps provider schedules
                  optimized by coordinating appointments in person or by
                  telephone. Keeps patient appointments on schedule by
                  confirming arrivals, reviewing service delivery and reminding
                  patients of upcoming visits. Maintains patient accounts by
                  obtaining and updating personal and financial information and
                  following up on third-party claims.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Medical biller */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },

                  }}
                >
                  Medicine
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Medical biller
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Checks eligibility and benefits verification for treatments,
                  hospitalizations and procedures. Reviews patient bills for
                  accuracy and completeness and obtains any missing information.
                  Prepares, reviews and transmits claims using billing software,
                  including electronic and paper claim processing. Follows up on
                  unpaid claims within standard billing cycle timeframes.
                  Verifies insurance payments for accuracy and compliance with
                  contract terms and resolves billing discrepancies when
                  necessary.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Medical coder */}
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },

                  }}
                >
                  Medicine
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Medical coder
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Accounts for coding and abstracting of patient encounters,
                  including diagnostic and procedural information and reportable
                  elements. Researches and analyzes data needs for
                  reimbursement, reviews medical records and identifies
                  documentation deficiencies. Assigns codes for reimbursement,
                  research and compliance with regulatory requirements. Follows
                  coding conventions, serves as coding consultant to providers
                  and identifies discrepancies and potential quality of care or
                  billing issues.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 2 - 1 column: Medical transcriptionists */}
          <Grid container spacing={{ xs: 6, md: 8 }}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  px: { xs: 1, md: 3 },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },

                  }}
                >
                  Medicine
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Medical transcriptionists
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Listen to recorded dictation from doctors and other healthcare
                  professionals and transcribe it into patient histories, exam
                  notes, operative reports, referral letters, discharge
                  summaries and other documents. Review and edit drafts prepared
                  by speech-recognition software to ensure accuracy,
                  completeness and consistent style. Translate medical
                  abbreviations and jargon into the appropriate long form,
                  identify inconsistencies or missing information that could
                  compromise patient care and follow up with providers when
                  clarification is needed. Enter final reports into electronic
                  health record systems while maintaining strict patient
                  confidentiality.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "150px solid transparent",
                    borderRight: "150px solid transparent",
                    borderTop: "90px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Medical;
